import _ from 'lodash-es';

export default class OpenIdHelper {
    /**
     *  Check if social sso is enable from
     * @param array $obj
     * @return bool
     */
    static isEnabled = (obj) => {
        if (!obj['type']) {
            return false;
        }
        if (['facebook', 'google', 'sharecare', 'apple'].indexOf(obj['type']) < 0) {
            return false;
        }

        const loginType = obj['type'];
        const userType = (obj['user_type'] === window.CONST.USER.TYPE.MEMBER) ? 'member' : 'provider';

        const enabled = this.#getConfig(userType, loginType);

        //Check if apple login => check if other method is enabled => apple enabled
        if (obj['type'] === 'apple' && !enabled) {
            var platforms = ['facebook', 'google', 'sharecare'];
            for (var i in platforms) {
                if (this.#getConfig(userType, platforms[i])) {
                    return true;
                }
            }
        }

        return enabled;
    }

    /**
     * Get Config from account and fallback to config in php
     *
     * @param string $type google | facebook
     * @return bool
     */
    static #getConfig = (userType, loginType) => {
        return _.get(window.CONFIG.Account, "auth.settings." + userType + "." + loginType + ".enabled", false);
    }
}